//import EditTitlePageNode from "../TitlePageNode/EditTitlePageNode"
import DisplayTitlePageNode from '../TitlePageNode/DisplayTitlePageNode';

import DisplayBannerNode from '../BannerNode/DisplayBannerNode';

import EditHeadingNode from '../HeadingNode/EditHeadingNode';
import DisplayHeadingNode from '../HeadingNode/DisplayHeadingNode';

import EditTextNode from '../TextNode/EditTextNode';
import DisplayTextNode from '../TextNode/DisplayTextNode';

import DisplayVerticalBarChart from '../VerticalBarChart/DisplayVerticalBarChart';
import EditVerticalBarChart from '../VerticalBarChart/EditVerticalBarChart.vue';

import DisplayHorizontalBarChart from '../HorizontalBarChart/DisplayHorizontalBarChart';
import EditHorizontalBarChart from '../HorizontalBarChart/EditHorizontalBarChart.vue';

import DisplayHorizontalLineChart from '../HorizontalLineChart/DisplayHorizontalLineChart';
//import EditHorizontalLineChart from "../HorizontalBarChart/EditHorizontalLineChart.vue"

import DisplayTable from '../SimpleTable/DisplayTable';
import EditTable from '../SimpleTable/EditTable.vue';

import PriorityMatrix from '../PriorityMatrix/PriorityMatrix';
import EditPriorityMatrix from '../PriorityMatrix/EditPriorityMatrix.vue';

import PositiveNegativeBarChart from '../PositiveNegativeBarChart/PositiveNegativeBarChart';

import TextThemeTable from '../TextThemeTable/DisplayTable.vue';

import OutliersUL from '../Outliers/OutliersUL.vue';

// below moved to EditablePositiveNegativeBarChart because this work was not completed
// import EditPositiveNegativeBarChart from "../PositiveNegativeBarChart/EditPositiveNegativeBarChart.vue"

import Placeholder from '../Placeholder/Placeholder';

import { markRaw } from 'vue'; // Import markRaw for Vue3

const nodeTypes = {
  titlePage: {
    //edit: markRaw(EditTitlePageNode), Removing for now, as this relies on content as an array instead of as an object and this breaks the edit
    view: markRaw(DisplayTitlePageNode),
  },
  banner: {
    view: markRaw(DisplayBannerNode),
  },
  heading: {
    edit: markRaw(EditHeadingNode),
    view: markRaw(DisplayHeadingNode),
  },
  text: {
    edit: markRaw(EditTextNode),
    view: markRaw(DisplayTextNode),
  },
  verticalBarChart: {
    view: markRaw(DisplayVerticalBarChart),
    edit: markRaw(EditVerticalBarChart),
  },
  horizontalBarChart: {
    view: markRaw(DisplayHorizontalBarChart),
    edit: markRaw(EditHorizontalBarChart),
  },
  horizontalLineChart: {
    view: markRaw(DisplayHorizontalLineChart),
  },
  table: {
    view: markRaw(DisplayTable),
    edit: markRaw(EditTable),
  },
  priorityMatrix: {
    view: markRaw(PriorityMatrix),
    edit: markRaw(EditPriorityMatrix), // these are not being used, we should use them
  },
  positiveNegativeBarChart: {
    view: markRaw(PositiveNegativeBarChart),
    // edit: EditPositiveNegativeBarChart
  },
  textThemeTable: {
    view: markRaw(TextThemeTable),
  },
  outliersUL: {
    view: markRaw(OutliersUL),
  },
  placeholder: {
    view: markRaw(Placeholder),
  },
};

export default nodeTypes;
